export default __webpack_public_path__ + "static/media/npm.9d05915a.svg";